import { render, staticRenderFns } from "./showUnionMsg.vue?vue&type=template&id=744e4028&scoped=true&"
import script from "./showUnionMsg.vue?vue&type=script&lang=js&"
export * from "./showUnionMsg.vue?vue&type=script&lang=js&"
import style0 from "./showUnionMsg.vue?vue&type=style&index=0&id=744e4028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744e4028",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744e4028')) {
      api.createRecord('744e4028', component.options)
    } else {
      api.reload('744e4028', component.options)
    }
    module.hot.accept("./showUnionMsg.vue?vue&type=template&id=744e4028&scoped=true&", function () {
      api.rerender('744e4028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/components/showUnionMsg.vue"
export default component.exports